import type { GetLockboxesForListingResponse, JsonObject } from '@/app-package';
import axios from 'axios';

export type ListingSentrilocks = JsonObject<
  (GetLockboxesForListingResponse[number] & {
    userMlsNumber?: { board: string; boardId: string; number: string };
    listing: { _id: string };
  })[]
>;

const getListingSentrilocks = async (listingId: string) => {
  const { data } = await axios.get<ListingSentrilocks>(
    `/lockbox_sentrilock/listing/${listingId}`,
  );

  return data;
};

export default getListingSentrilocks;
